import * as e from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/SealCheck.es.js";
const o = e.forwardRef((a, c) => /* @__PURE__ */ e.createElement(r, { ref: c, ...a, weights: t }));
o.displayName = "SealCheckIcon";
const n = o;
export {
  o as CircleWavyCheckIcon,
  n as SealCheck,
  o as SealCheckIcon
};
